import { renderActionIcon } from './utils/RenderActionIcon';
import PropTypes from 'prop-types';

const returnFocus = (event, idForFocus) => {
  if (event.key === 'Escape') {
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));

    if (idForFocus) {
      const button = document.getElementById(idForFocus);
      button?.focus();
    }
  }
};

/**
 * The edit button with pencil icon in the tabe actions
 */
export const EditButton = ({
  handleOpen, data, focusIdOnEscape, ref,
}) => {
  return (
    <button
      key={`edit-${data.id}`}
      className='actions-container'
      onClick={handleOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          handleOpen();
        }
        returnFocus(event, focusIdOnEscape);
      }}
      title={`Edit ${data.name}`}
      tabIndex={-1}
      ref={ref}
    >
      <i
        aria-hidden='true'
        className={renderActionIcon('edit')}
      />
      <a>Edit</a>
    </button>
  );
};


/**
 * The delete button with trash icon in the tabe actions
 */
export const DeleteButton = ({
  handleOpen, data, focusIdOnEscape, ref,
}) => (
  <button
    key={`delete-${data.id}`}
    className='actions-container'
    onClick={handleOpen}
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        handleOpen();
      }
      returnFocus(event, focusIdOnEscape);
    }}
    title={`Delete ${data.name}`}
    tabIndex={-1}
    ref={ref}
  >
    <i
      aria-hidden='true'
      className='fa-solid fa-trash'
    />
    <a>Delete</a>
  </button>
);

export const EllipsisTrigger = () => (
  <>
    <span className='sr-only' aria-hidden='true'>
      Toggle Options
    </span>
    <i
      role='img'
      className='fa fa-ellipsis-h'
      title='Toggle Options'
    />
  </>
);

const actionButtonPropTypes = {
  handleOpen: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  focusIdOnEscape: PropTypes.string,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

EditButton.propTypes = actionButtonPropTypes;
DeleteButton.propTypes = actionButtonPropTypes;
